import { h, Component, createRef } from "preact";

import { classNames } from "../helpers";

export default class Modal extends Component {
  ref = createRef();

  componentWillUnmount() {
    this.props.onClose && this.props.onClose();

    document.documentElement.style.overflow = "scroll";
    document.body.scroll = "yes";
  }

  componentDidUpdate() {
    if (this.props.visible) {
      document.documentElement.style.overflow = "hidden";
      document.body.scroll = "no";
    } else {
      document.documentElement.style.overflow = "scroll";
      document.body.scroll = "yes";
    }

    if (this.props.noScroll) {
      this.ref.current.style.overflowY = "hidden";
    } else {
      this.ref.current.style.overflowY = "auto";
    }
  }

  render({ children, fullPage, noScroll }) {
    return (
      <div
        class={classNames("nioomi-modal", fullPage && "nioomi-modal--fullPage")}
        ref={this.ref}
      >
        {children}
      </div>
    );
  }
}
